import { useContext } from "react";
import { AppContext } from "../../Context/AppContext";
import { capitalize } from "../../HelperFunctions/capitalize";
import classes from "./LandingPageNewsLetterSignUp.module.css";

const LandingPageNewsLetterSignUp = () => {
  // Context
  const {
    newsLetterEmail,
    setNewsLetterEmail,
    emailSignUpRequestObject,
    addEmailSubscriber,
  } = useContext(AppContext);
  return (
    <div className={classes.container}>
      <h4>
        Stay up to date with the{" "}
        <br className={classes.mobileBreak} />
        latest opportunities, news, and events from AIESEC in Nigeria.
      </h4>
      <div className={classes.form}>
        <div className={classes.inputWrap}>
          <input
            type="text"
            placeholder="ENTER YOUR EMAIL"
            value={newsLetterEmail}
            onChange={(e) => {
              setNewsLetterEmail(e.target.value);
            }}
          />
        </div>

        <div className={classes.submitWrap}>
          <button
            onClick={addEmailSubscriber}
            disabled={!newsLetterEmail || !newsLetterEmail.includes("@")}
          >
            {emailSignUpRequestObject.isLoading ? "Loading..." : "SUBMIT"}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 12 12"
              fill="none"
              aria-hidden="true"
            >
              <path
                opacity="0.9"
                d="M1.5 10.5L11 1M11 1H4.18868M11 1V7.63208"
                stroke="#fff"
                strokeWidth="1.43396"
              />
            </svg>
          </button>
          <svg
            className={classes.submitUnderline}
            xmlns="http://www.w3.org/2000/svg"
            width="104"
            height="8"
            viewBox="0 0 125 9"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M1 7.94615C29.5101 7.94615 57.8234 2.32561 86.4499 2.11512C98.3222 2.02783 110.086 1.95706 121.94 2.11512C125.151 2.15794 125.009 1.52784 121.796 1.46722C116.092 1.3596 110.85 0.378442 105.023 0.675354C94.2642 1.22357 83.4704 0.831205 72.7001 1.32324C50.7367 2.32664 28.7512 1.95116 6.83105 2.76301"
              stroke="#fff"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <span
          className={classes.warning}
          style={
            emailSignUpRequestObject.error
              ? { color: "#ffd6d0" }
              : { color: "#ffffff" }
          }
        >
          {capitalize(emailSignUpRequestObject.error) ||
            capitalize(emailSignUpRequestObject.data)}
        </span>
      </div>
    </div>
  );
};

export default LandingPageNewsLetterSignUp;
